export function handleErrors(err: any) {
  console.error(err);
}
